import Option from '@/components/form/types/Option.ts';
import useGetCostCategories from '@/features/dashboard/costCategories/hooks/useGetCostCategories.ts';

/** Do wyboru idą tylko żywe kategorie — zarchiwizowane zostają na historii. */
export default function useGetCostCategoryOptions() {
  const { data, isLoading } = useGetCostCategories(false);

  const options: Option[] =
    data?.map((category) => ({
      value: category.id,
      label: category.name,
    })) ?? [];

  return { options, isLoading };
}
